import { IconButton, makeStyles, styled } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import HelpIcon from '@material-ui/icons/Help';
import InfoIcon from '@material-ui/icons/Info';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import PanToolIcon from '@material-ui/icons/PanTool';
import RemoveIcon from '@material-ui/icons/Remove';
import { AppLink, colors, div, Link, PopoverValue } from 'lqx-react';
import * as React from 'react';
import { RowH2Bold } from '../inmatch';
import AddComment from '@material-ui/icons/AddComment';

export const InvoiceMatch = ({ match }) => {
    return (
        <LongChip>
            <AppLink
                href={match ? match.isReconciled ? `/bank-transactions/details/${match.id}` : `/matching/unreconciled?paymentId=${match.id}` : '#'}
                returnUrl
            >
                <PaymentIcon match={match} fontSize="large" />
                <MatchIcon match={match} />
            </AppLink>
        </LongChip>
    )
}

const PaymentIcon = styled(MonetizationOnIcon)({
    color: (props: any) =>
        props.match ? (
            (props.match.originType === 'heuristic'|| props.match.originType === 'greedy') ?
                colors.yellow :
                colors.green
        ) :
            '#dcdcdc'
})


export const RAButton = ({ remittanceAdviceIds, raLinkRoot }) => {
    return (
        <IconContainer>
            {remittanceAdviceIds && remittanceAdviceIds.length ?
                <PopoverValue
                    anchorAlign="left"
                    transformAlign="center"
                    withCloseIcon={false}
                    label={
                        <RaMatchIcon fontSize="large" />
                    }
                >

                    {remittanceAdviceIds.length ?
                        <>
                            <RowH2Bold>Remittance Advices</RowH2Bold>

                            {remittanceAdviceIds.map(id =>
                                <div key={id} >
                                    <AppLink href={`${raLinkRoot}${id}`}>{id}</AppLink>
                                </div>
                            )}
                        </> : null}
                </PopoverValue>
                :
                <RaMatchIcon fontSize="large" disabled />
            }
        </IconContainer>
    )
}

export const RIButton = ({ paymentInfoIds }) => {
    return (
        <IconContainer>
            {paymentInfoIds && paymentInfoIds.length ?
                <PopoverValue
                    anchorAlign="left"
                    transformAlign="center"
                    withCloseIcon={false}
                    label={
                        <PaymentInfoMatchIcon fontSize="large" />
                    }
                >
                    {paymentInfoIds.length ?
                        <>
                            <RowH2Bold>Payment Remittance Info</RowH2Bold>

                            {paymentInfoIds.map(id =>
                                <div key={id} >
                                    <AppLink href={`/bank-transactions/details/${id}`} returnUrl>{id}</AppLink>
                                </div>
                            )}
                        </> : null}
                </PopoverValue>
                :
                <PaymentInfoMatchIcon fontSize="large" disabled />
            }
        </IconContainer>
    )
}

export const InvoicePaymentButton = ({ matchedPayments }) => {
    return (
        <IconContainer>
            {matchedPayments && matchedPayments.length ?
                <PopoverValue
                    anchorAlign="left"
                    transformAlign="center"
                    withCloseIcon={false}
                    label={
                        <LongChip>
                            <PaymentIcon match={matchedPayments.first()} fontSize="large" />
                            <MatchIcon match={matchedPayments.first()} />
                        </LongChip>
                    }
                >
                    {matchedPayments.length ?
                        <>
                            <RowH2Bold>Matched Payments</RowH2Bold>

                            {matchedPayments.map(matchedPayment =>
                                <div key={matchedPayment.id}>
                                    <AppLink 
                                        href={matchedPayment.isReconciled ? `/bank-transactions/details/${matchedPayment.id}` : `/matching/unreconciled?paymentId=${matchedPayment.id}` } 
                                        returnUrl
                                    >{matchedPayment.id}</AppLink>
                                </div>
                            )}
                        </> : null}
                </PopoverValue>
                :
                <LongChip>
                    <PaymentIcon fontSize="large" />
                    <MatchIcon />
                </LongChip>
            }
        </IconContainer>
    )
}

export const EmailButton = ({ onClick }) => {
    return (
        <IconContainer>
            <IconButton aria-label="Email" size="small"
                onClick={onClick}
            >
                <MailOutlineIcon fontSize="large" />
            </IconButton>
        </IconContainer>)
}

export const IconContainer = div({
    margin: '0 8px 0 8px'
})

const LongChip = div({
    margin: '0 4px 0 4px',
    borderRadius: 24,
    backgroundColor: '#e5e5e5',
    paddingRight: 8,
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer'
})

function getMatchIcon(originType) {
    switch (originType) {
        case 'manual': return ManualMatchIcon;
        case 'remittance_advice': return RaMatchIcon;
        case 'remittance_info': return PaymentInfoMatchIcon;
        case 'heuristic':
        case 'greedy':
             return HeuristicMatchIcon;
    }
}

const disabledIconStyles = {
    color: (props: any) => props.disabled ? '#dcdcdc' : colors.green
}

const NoMatchIcon = styled(RemoveIcon)({
    color: '#dcdcdc'
});


const YellowPaymentIcon = styled(MonetizationOnIcon)({
    color: colors.yellow
})

const ManualMatchIcon = styled(PanToolIcon)({
    color: colors.yellow
});

const RaMatchIcon = styled(DescriptionIcon)(
    disabledIconStyles
);

const HeuristicMatchIcon = styled(HelpIcon)({
    color: colors.yellow
});

const PaymentInfoMatchIcon = styled(InfoIcon)(
    disabledIconStyles
);

const MatchIcon = ({ match = null }) => {
    const TheIcon = match ?
        getMatchIcon(match.originType) :
        NoMatchIcon;

    return <TheIcon />;
}

export const InblockIcon = ({ src,classes }) => {
    return <img className={ classes.root } src={ src } alt='InBlock' />
}

export const SocCommentStatus = ({ hasSocComment }) => {
    const styles = socCommentStyles();
    return (
        <div className={styles.root} title={hasSocComment ? 'Invoice has a new SOA Comment' : ''}>
            <AddComment htmlColor={hasSocComment ? colors.blue : colors.lightGrey} />
        </div>
    )
}

const socCommentStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 50
    }
})